import { useTranslation } from 'react-i18next';
import styled from 'styled-components'
import { typeface, get_color, respond } from '../assets/styles/index';
import feature_logo01 from '../assets/images/key_feature_01.svg';
import feature_logo02 from '../assets/images/key_feature_02.svg';
import feature_logo03 from '../assets/images/key_feature_03.svg';
import { PrimaryTitle } from '../component/PrimaryTitle';

const Container = styled('div')`
  display: flex;
  padding-bottom: 64px;
  ${respond(['m','s'], `
    flex-direction: column;
  `)}
  .body{
    flex: 1;
    ${respond(['t'], `
      padding-left: 12px;
    `)}
  }
`;

const Content = styled('div')`
  ${typeface('body2')}
  padding-bottom: 16px;
  ${respond(['s'], `
    ${typeface('body4')}
  `)}
`;

const PointList = styled('div')`
  ${typeface('body1')}
  padding: 8px 0;
  border-bottom: 1px solid ${get_color('grey06')};
  display: flex;
  align-items: center;
  i {
    background-size: 48px;
    min-height: 48px;
    min-width: 48px;
    display: block;
    margin-right: 16px;

    &.calculate{
      background-image: url(${feature_logo01});
    }
    &.review{
      background-image: url(${feature_logo02});
    }
    &.quickLink{
      background-image: url(${feature_logo03});
    }
  }
  ${respond(['s'], `
    ${typeface('body3')}
  `)}
`;

const ImportantNote = styled('div')`
  ${typeface('body11')}
  color: ${get_color('grey02')};
  padding-top: 24px;
  .title{
    color: ${get_color('grey01')};
    ${typeface('body10')}
    padding-bottom: 4px;
  }
`;

const ServiceOverview = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <PrimaryTitle>{t('serviceOverview.title')}</PrimaryTitle>
      <div className="body">
        {/* <Content>{t(`serviceOverview.content`)}</Content> */}
        <div role="list">
          <PointList role="listitem"><i className="calculate" />{t(`serviceOverview.calculate`)}</PointList>
          <PointList role="listitem"><i className="review" />{t(`serviceOverview.review`)}</PointList>
          <PointList role="listitem"><i className="quickLink" />{t(`serviceOverview.quickLink`)}</PointList>
        </div>
        <ImportantNote>
          <div role="heading" aria-level={3} className="title">{t('serviceOverview.note.title')}</div>
          {t('serviceOverview.note.content')}
        </ImportantNote>
      </div>
    </Container>
  );
}

export default ServiceOverview;
